import { get, ref } from "firebase/database";
import { db } from "../firebaseConfig";
import { PartnerInvestmentRecord } from "../../models/partnerInvestment";

const getDateKey = (value: unknown): string | null => {
	if (typeof value !== "string") return null;
	const trimmed = value.trim();
	if (!trimmed) return null;

	// Use date-only portion if already ISO-like
	if (/^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
		return trimmed.substring(0, 10);
	}

	const parsed = new Date(trimmed);
	if (Number.isNaN(parsed.getTime())) return null;
	return parsed.toISOString().substring(0, 10);
};

export const getPartnerInvestmentsByDateRange = async (
	startDate: string,
	endDate: string
): Promise<PartnerInvestmentRecord[]> => {
	try {
		const investmentsRef = ref(db, "partnerInvestments");
		const snapshot = await get(investmentsRef);

		if (!snapshot.exists()) {
			return [];
		}

		const investmentsData = snapshot.val() as Record<
			string,
			PartnerInvestmentRecord
		>;
		console.log("Fetched partner investments:", investmentsData);
		const filteredInvestments = Object.entries(investmentsData)
			.map(([id, investment]) => ({
				...(investment as PartnerInvestmentRecord),
				id
			}))
			.filter((investment) => {
				const investmentDateKey = getDateKey(investment.investmentDate);
				if (!investmentDateKey) return false;
				return (
					investmentDateKey >= startDate &&
					investmentDateKey <= endDate
				);
			});
		console.log("Filtered partner investments:", filteredInvestments);
		return filteredInvestments;
	} catch (error) {
		console.error("Error fetching partner investments:", error);
		throw error;
	}
};
